import { getDevice } from '../utils/device';
import axios from 'axios';
function getToken() {
  return localStorage.getItem('userToken');
}

export const axiosInstance = axios.create({
  baseURL: 'https://stream.livingscriptures.com/api/v4',
});

axiosInstance.interceptors.request.use((config) => {
  const platform = navigator.platform;
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Tizen')) {
    const tizenIndex = userAgent.indexOf('Tizen');
    const versionStart = tizenIndex + 'Tizen '.length;
    let version = userAgent.slice(versionStart, userAgent.indexOf(' ', versionStart));

    // Remove closing parenthesis if present
    version = version.replace(')', '');

    const device = getDevice();
    // Add custom headers here
    config.headers['LSI-Client-Device'] = device;
    config.headers['LSI-Client-Platform'] = platform;
    config.headers['LSI-Client-Version'] = version;
  }

  if (userAgent.includes('Web0S')) {
    const webOSIndex = userAgent.indexOf('Web0S');
    const versionStart = webOSIndex + 'Web0S'.length + 1; // Add 1 to skip the semicolon
    let version = userAgent.slice(versionStart, userAgent.indexOf(';', versionStart));

    // Assuming you have the getDevice() function defined elsewhere
    const device = getDevice();
    // Assuming you have the platform variable defined elsewhere
    const platform = 'WebOS';
    // Assuming you have the config object defined elsewhere
    config.headers['LSI-Client-Device'] = device;
    config.headers['LSI-Client-Platform'] = platform;
    config.headers['LSI-Client-Version'] = version;
  }

  const token = getToken();
  if (token) {
    config.params = {
      ...config.params,
      token: token,
    };
  }
  return config;
});

const request = async ({ ...options }) => {
  const onSuccess = (response) => response;
  const onError = (error) => {
    // DISPLAY API ERROR MESSAGES ON DEV ENVIRONMENT
    // if (error.response.status === 400 || error.response.status === 401) {
    //   window.location.href = '';
    //   localStorage.clear();
    // }
    if (process.env.NODE_ENV === 'development') {
      if (error.response) {
        // Request was made but server responded with something
        // other than 2xx
        console.error('Status:', error.response.status);
        console.error('Data:', error.response.data);
        console.error('Headers:', error.response.headers);
      } else {
        // Something else happened while setting up the request
        // triggered the error
        console.error('Error Message:', error.message);
      }

      return Promise.reject(error.response || error.message);
    }
  };

  return axiosInstance(options).then(onSuccess).catch(onError);
};

export default request;
